export default function About() {
  return (
    <section id="about" className="bg-kiln-dark py-20 md:py-28 overflow-hidden">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="mb-14">
          <span className="inline-block bg-tankan/20 text-tankan-light text-xs font-rounded font-bold tracking-widest px-3 py-1.5 rounded-full mb-4">
            / ABOUT
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-rounded font-black text-white leading-tight max-w-xl">
            FUBATE「ふぅばてぇ」<br />
            手ごね窯焼きピザ専門店
          </h2>
        </div>

        {/* Content grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          {/* Text */}
          <div>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-8">
              「ふうばて」～ 大畑（おおはた）。この土地を、島の言葉で読むと「ふうば」。
              宇検村の入口にあるこの場所の名前が、そのままお店の名前になりました。
            </p>
            <p className="text-white/95 font-rounded text-base md:text-lg leading-[1.9] mb-8">
              坂を下ると、右側に見える小さなお店。<br />
              靴を脱いでくつろげる空間で、焼きたてのピザをお渡しします。<br />
              ドライブの途中にふらっと寄って、<br />
              ピザを持って山へ、海へ。<br />
              宇検村に着く前の、ちょっと寄り道したくなる場所です。
            </p>

            <div className="mt-10 flex gap-6">
              <div className="text-center">
                <p className="text-4xl font-rounded font-black text-tankan">35<span className="text-xl">cm</span></p>
                <p className="text-white/70 text-xs font-rounded mt-1">ピザの直径</p>
              </div>
              <div className="w-px bg-white/10" />
              <div className="text-center">
                <p className="text-4xl font-rounded font-black text-tankan">400<span className="text-xl">℃</span></p>
                <p className="text-white/70 text-xs font-rounded mt-1">窯の温度</p>
              </div>
              <div className="w-px bg-white/10" />
              <div className="text-center">
                <p className="text-4xl font-rounded font-black text-tankan">5<span className="text-xl">分</span></p>
                <p className="text-white/70 text-xs font-rounded mt-1">焼き時間</p>
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="flex flex-col gap-4">
            <div className="w-full h-60 md:h-72 rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/0d90661f7366e964b8673ef2f8427127/153c83269f1a39ee3accbc1eb180a63c.webp"
                alt="宇検村の坂道 - 右側にふうばてが見える"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
